// Message utility functions
import { toTimestamp } from "./formatters";
import { safeDomId } from "./domUtils";

export function isMineMessage(message, myId) {
  if (typeof message?.mine === "boolean") return message.mine;
  if (myId == null || message?.fromUserId == null) return false;
  return String(message.fromUserId) === String(myId);
}

export function isMessageDeleted(message) {
  return Boolean(message?.deleted || message?.isDeleted);
}

export function isMessageEdited(message) {
  if (!message || typeof message !== "object") return false;
  if (message.isEdited === true || message.edited === true || message.wasEdited === true || message.is_edited === true) {
    return true;
  }
  if (message.editedAt || message.edited_at || message.editedWhen || message.edited_when) return true;
  return false;
}

export function isReadByMe(message, isPsychologistLike) {
  const roleBased = Boolean(isPsychologistLike ? message?.isReadByPsychologist : message?.isReadByClient);
  if (typeof message?.readByMe === "boolean") return Boolean(message.readByMe || roleBased);
  return roleBased;
}

export function isReadByOther(message, isPsychologistLike) {
  const roleBased = Boolean(isPsychologistLike ? message?.isReadByClient : message?.isReadByPsychologist);
  if (typeof message?.readByOther === "boolean") return Boolean(message.readByOther || roleBased);
  return roleBased;
}

export function messageDomKey(message) {
  if (message?.id != null) return safeDomId(message.id);
  if (message?.clientId != null) return safeDomId(message.clientId);
  return safeDomId(`msg-${toTimestamp(message?.createdAt)}`);
}

export function isServerMessageId(value) {
  const num = Number(value);
  return Number.isFinite(num) && num > 0;
}
